"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = A11y;
exports.propTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("@paprika/helpers");

/* eslint-disable react/no-unused-prop-types */

/* A shell component to collect and distribute a11y related props and DOM
 * attributes to the appropriate (interactive) element
 */
function A11y() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}

var propTypes = {
  /** DOM id attribute for focussable control (trigger element or ul element if isInline=true) */
  id: _propTypes["default"].string,

  /** Ref for a DOM element containing the label for this component */
  refLabel: (0, _helpers.RefOf)(_propTypes["default"].node)
};
exports.propTypes = propTypes;
A11y.displayName = "ListBox.A11y";
A11y.propTypes = propTypes;
A11y.defaultProps = {
  id: null,
  refLabel: null
};
//# sourceMappingURL=A11y.js.map